'use client'

import { StoreList } from '../StoreList'

import { Page } from '@/shared/ui/Page'

interface StoreCategoryPageProps {
  categoryId: number
}

export function StoreCategoryPage({ categoryId }: StoreCategoryPageProps) {
  return (
    <Page className="bg-[#0389D5] bg-[url('/bgs/store-page.svg')]">
      <StoreList categoryId={categoryId} />
    </Page>
  )
}
